(($, Drupal) => {
  const initializeScrollRestoration = () => {
    const loadingScreen = document.getElementById('js-loading-screen');

    document.addEventListener('submit', () => {
      sessionStorage.setItem("scrollRestore", "true");
    });

    if (sessionStorage.getItem("scrollRestore") === "true") {
      const savedPos = parseInt(sessionStorage.getItem("scrollPos"), 10);
      if (!isNaN(savedPos)) {
        requestAnimationFrame(() => {
          window.scrollTo(0, savedPos);
          sessionStorage.removeItem("scrollRestore");
          sessionStorage.removeItem("scrollPos");

          // After restoring scroll, check for element scroll
          setTimeout(() => {
            const scrollToElement = sessionStorage.getItem('scrollToElement');
            if (scrollToElement) {
              const el = document.getElementById(scrollToElement);
              if (el) {
                const offset = 300;
                const top = el.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
                sessionStorage.removeItem('scrollToElement');
              }
            }
            if (loadingScreen) loadingScreen.style.display = 'none';
          }, 150);
        });
      } else {
        // Invalid scroll position - hide
        if (loadingScreen) loadingScreen.style.display = 'none';
      }
    } else {
      // No scroll restoration needed - hide
      if (loadingScreen) loadingScreen.style.display = 'none';
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("scrollPos", window.scrollY);
    });
  };

  Drupal.behaviors.restoreScroll = {
    attach: (context) => {
      if (context === document) {
        // Run only once
        initializeScrollRestoration();
      }
    },
  };
})(jQuery, Drupal);
